<template>
<div id="app">

  <div class="app-content">
    
      <router-view></router-view>
    
  </div>

</div>
</template>

<script>
import ShareImpl from '@/Share/Share.js'
window.onload = function () {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
}
export default {
  name: 'App',
  components: {

  },
  data() {
    return {
      isWechat: true, // 是否为微信环境（true：是；false：否）
      wx: {
        wxAppId: '', // 微信公众号 ID
        wxSecret: '', // 微信公众号 密钥
        code: '', // 授权获取的 code
        openid: '', // 授权获取的 openid
        unionid: '' // 授权获取的用户唯一标识 unionid
      },
    }
  },
  created() {
    // 检测是浏览器端还是微信端
    let ua = navigator.userAgent.toLowerCase();
    if (String(ua.match(/MicroMessenger/i)) === 'micromessenger') {
      this.isWechat = true
    } else {
      this.isWechat = false
    }

  },
   mounted(){
    let  shareImg = 'https://jingcaicheshi.com/LOGO.png'
        let  shareTitle = '精彩车市';
        let url = window.location.href;
        
        ShareImpl({
            shareTitle: shareTitle,
            shareDesc: '精彩车市更多精彩，赶快来看看吧。',
            shareUrl: url,
            shareImg: shareImg,
            });
  }
}
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100%;
  

  

}
</style>
